import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Results from "./components/Results";
import Footer from "./components/Footer";
import Stars from "./components/Stars";
import ShootingStars from "./components/ShootingStars";
import Privacy from "./components/Privacy";

function App() {
  const location = useLocation();
  
  return (
    <div className="relative min-h-screen text-white">
      {/* Fixed Background Layer */}
      <div className="fixed inset-0 z-0">
        <div className="w-full h-full bg-gradient-to-b from-gray-900 via-gray-800 to-black" />
        <Stars />
        {location.pathname === "/" && <ShootingStars />}
      </div>

      {/* Foreground Layer */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />

        <main className="flex-1 px-4 pt-5 pb-5">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/results" element={<Results />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default App;
